import { useMemo } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import { createPersonalizationSearchString, getPersonalizationQueryParams } from 'personalization-lib/utils/urls/queryParams';
import { getVariantsEditorUrl } from 'personalization-lib/utils/urls';
const useBackToVariantsEditorUrl = strategyId => {
  const {
    search: currentSearch
  } = useLocation();
  const currentQueryParams = useMemo(() => getPersonalizationQueryParams(currentSearch), [currentSearch]);
  const isStrategyIdValid = !!strategyId && strategyId === currentQueryParams.strategyId;
  return isStrategyIdValid ? getVariantsEditorUrl(strategyId, {
    search: createPersonalizationSearchString({
      fromCreate: currentQueryParams.fromCreate
    })
  }) : undefined;
};
export default useBackToVariantsEditorUrl;